import { useEffect, useState } from "react";
import RoundedImg from "../../../../Universal/RoundedImg.component";
import DateFormater from "../../../../../Utils/DateFormater.utils";
const ScrollableShortCardComponentCard = ({
  name,
  date,
  studentClass,
  image,
  _id,
}) => {
  const [dateToview, setDateToView] = useState("");
  useEffect(() => {
    setDateToView(DateFormater(date));
  }, [date]);

  return (
    <button
      type="button"
      className="transparentBtn w-full flex-row align-center justify-between g-1 p-05"
      style={{ borderBottom: "2px solid var(--borderGray)" }}
      onClick={() => console.log(_id)}
    >
      <div className="flex-row align-center justify-start g-05">
        <RoundedImg src={image} height="2.1rem" width="2.1rem" />
        <div className="flex-col align-start justify-start ">
          <span
            className="color-black t-13 poppins text-align-left"
            style={{ lineHeight: "1" }}
          >
            {name}
          </span>
          <span className="w-fit poppins color-grayColor t-10">
            {dateToview}
          </span>
        </div>
      </div>
      <span className="color-greenColor flex text-align-end text-no-wrap t-10">
        {studentClass}
      </span>
    </button>
  );
};

export default ScrollableShortCardComponentCard;
